import {
  type OpportunitiesSearchOptions,
  initialOpportunityOptions,
} from "@repo/api";

export const hasActiveSort = (options: OpportunitiesSearchOptions) => {
  return (
    options.sortKey !== initialOpportunityOptions.sortKey ||
    options.sortOrder !== initialOpportunityOptions.sortOrder
  );
};
